/**
 * Centralized error message constants for foundation domain errors.
 * All domain errors must use these constants instead of inline string literals.
 */

export const FoundationErrorConstants = {
  STATE_ENTITY_TYPE: "state",
} as const;

export const FoundationErrorMessages = {
  entityNotFound: (entityType: string, identifier: string): string =>
    `${entityType} with identifier '${identifier}' not found`,

  invalidStateTransition: (
    entityType: string,
    currentState: string,
    targetState: string,
  ): string =>
    `Cannot transition ${entityType} from ${currentState} to ${targetState}`,

  enumValidationFailed: (
    enumName: string,
    invalidValue: string,
    validValues: string[],
  ): string =>
    `Invalid ${enumName}: '${invalidValue}'. Valid values: ${validValues.join(", ")}`,

  invalidNormalizedValue: (typeName: string, value: number): string =>
    `Invalid ${typeName}: ${value}. Value must be in range [0, 1].`,

  validationFailed: "Validation failed",

  validationFailedWithCount: (errorCount: number): string =>
    `Validation failed with ${errorCount} error(s)`,
} as const;
